import Header from '../Header';
import { Helmet } from 'react-helmet-async';
import Footer from './Footer';
import '../../css/LegalPages.css';

const TermOfUse = () => {
    return (
        <>
            <Helmet>
                <title>Conditions d'utilisation | CC Débarras 14</title>
                <meta name="description" content="Conditions générales d'utilisation du site CC Débarras 14." />
                <link rel="canonical" href="https://ccdebarras14.fr/conditions-utilisation" />
                <meta property="og:title" content="Conditions d'utilisation | CC Débarras 14" />
                <meta property="og:description" content="Conditions générales d'utilisation du site CC Débarras 14." />
                <meta property="og:url" content="https://ccdebarras14.fr/conditions-utilisation" />
                <meta property="og:type" content="website" />
            </Helmet>

            <Header />
            <div className="legal-page">
                <div className="legal-content">
                    <h1>Conditions Générales d'Utilisation</h1>
                    
                    <section className="legal-section">
                        <h2>1. Objet</h2>
                        <p>Les présentes conditions générales d'utilisation (CGU) ont pour objet de définir les modalités et conditions d'utilisation du site internet de CC Débarras 14 ainsi que les services proposés.</p>
                        <p>L'utilisation du site implique l'acceptation pleine et entière des présentes CGU.</p>
                    </section>

                    <section className="legal-section">
                        <h2>2. Présentation de l'entreprise</h2>
                        <p><strong>Raison sociale :</strong> MADAME CARINE GAUTHERIE</p>
                        <p><strong>Nom commercial :</strong> CC Débarras 14</p>
                        <p><strong>SIREN :</strong> 848 965 612</p>
                        <p><strong>Adresse :</strong> RUE DES GENETS 7598 LE BIEF DU MOULIN, 14800 SAINT-ARNOULT, France</p>
                        <p><strong>Téléphone :</strong> 07 67 56 72 54</p>
                        <p><strong>Email :</strong> <a href="mailto:ccdebarras14@gmail.com">ccdebarras14@gmail.com</a></p>
                        
                        <p><strong>Activités :</strong></p>
                        <ul>
                            <li>Débarras de maisons, appartements, caves, greniers</li>
                            <li>Débarras de locaux professionnels</li>
                            <li>Tri et valorisation des objets récupérés</li>
                            <li>Vente d'objets de seconde main sur plateformes (Leboncoin, Facebook Marketplace)</li>
                            <li>Services de nettoyage et remise en état</li>
                        </ul>
                    </section>

                    <section className="legal-section">
                        <h2>3. Accès au site</h2>
                        <p>Le site est accessible 24h/24, 7j/7, sauf en cas de force majeure, de maintenance programmée ou d'interruption technique. CC Débarras 14 se réserve le droit d'interrompre temporairement l'accès au site pour des opérations de maintenance.</p>
                        <p>L'utilisateur reconnaît disposer de la compétence et des moyens nécessaires pour accéder et utiliser ce site internet.</p>
                    </section>

                    <section className="legal-section">
                        <h2>4. Services proposés</h2>
                        <h3>4.1 Prestations de débarras</h3>
                        <p>CC Débarras 14 propose des services de débarras professionnels incluant :</p>
                        <ul>
                            <li>Évaluation et devis gratuits sur site</li>
                            <li>Tri sélectif et évacuation des biens</li>
                            <li>Nettoyage des locaux (selon devis spécifique)</li>
                            <li>Valorisation et revente des objets récupérables</li>
                            <li>Dépôt en déchetterie des éléments non valorisables</li>
                            <li>Remise d'un justificatif de dépôt</li>
                        </ul>
                        
                        <h3>4.2 Conditions tarifaires</h3>
                        <p>Les prestations sont facturées selon un devis personnalisé établi après visite sur site. Le débarras peut être gratuit si la valeur des objets récupérables couvre les frais d'intervention, de transport et de manutention.</p>
                        <p>Dans le cas contraire, un devis détaillé sera établi pour l'enlèvement et l'évacuation des biens.</p>
                        
                        <h3>4.3 Zone d'intervention</h3>
                        <p>CC Débarras 14 intervient principalement sur Deauville et les communes environnantes. Pour les interventions plus éloignées, des frais de déplacement peuvent s'appliquer selon devis.</p>
                    </section>

                    <section className="legal-section">
                        <h2>5. Utilisation du site et formulaire de contact</h2>
                        <h3>5.1 Utilisation conforme</h3>
                        <p>L'utilisateur s'engage à utiliser le site de manière conforme à sa destination et aux présentes CGU. Il est strictement interdit :</p>
                        <ul>
                            <li>D'utiliser le site à des fins illégales ou frauduleuses</li>
                            <li>De porter atteinte aux droits des tiers</li>
                            <li>De diffuser des contenus inappropriés, diffamatoires ou contraires aux bonnes mœurs</li>
                            <li>De tenter d'accéder aux parties non publiques du site</li>
                            <li>De perturber le fonctionnement du site ou des serveurs</li>
                        </ul>
                        
                        <h3>5.2 Formulaire de contact et demandes de devis</h3>
                        <p>Le formulaire de contact permet de transmettre des demandes de devis. L'utilisateur garantit :</p>
                        <ul>
                            <li>L'exactitude des informations fournies</li>
                            <li>Sa capacité à engager juridiquement le bien concerné</li>
                            <li>La véracité de sa demande</li>
                        </ul>
                        <p>Les demandes fantaisistes ou manifestement non sérieuses pourront ne pas être traitées.</p>
                    </section>

                    <section className="legal-section">
                        <h2>6. Propriété intellectuelle</h2>
                        <p>Tous les éléments du site (textes, images, logos, design, architecture) sont protégés par le droit de la propriété intellectuelle. Toute reproduction, représentation, modification ou distribution, même partielle, est interdite sans autorisation préalable écrite de CC Débarras 14.</p>
                        <p>Les marques et logos de tiers (Leboncoin, Facebook, EmailJS) restent la propriété exclusive de leurs détenteurs respectifs.</p>
                        <p>Les photos avant/après présentées sur le site sont la propriété de CC Débarras 14 et ne peuvent être utilisées sans autorisation.</p>
                    </section>

                    <section className="legal-section">
                        <h2>7. Responsabilité</h2>
                        <h3>7.1 Responsabilité de CC Débarras 14</h3>
                        <p>CC Débarras 14 s'efforce de fournir des informations exactes et à jour sur le site mais ne peut garantir l'absence d'erreurs ou d'omissions. La responsabilité de CC Débarras 14 ne peut être engagée en cas de :</p>
                        <ul>
                            <li>Interruption temporaire ou définitive du site</li>
                            <li>Problèmes techniques, pannes ou dysfonctionnements</li>
                            <li>Dommages directs ou indirects résultant de l'utilisation du site</li>
                            <li>Perte de données ou corruption de fichiers</li>
                            <li>Intrusion malveillante de tiers</li>
                        </ul>
                        
                        <h3>7.2 Responsabilité de l'utilisateur</h3>
                        <p>L'utilisateur est entièrement responsable de :</p>
                        <ul>
                            <li>Son matériel informatique et de sa connexion internet</li>
                            <li>L'utilisation qu'il fait du site</li>
                            <li>La véracité des informations qu'il transmet</li>
                            <li>Le respect des présentes CGU</li>
                        </ul>
                    </section>

                    <section className="legal-section">
                        <h2>8. Liens externes et plateformes partenaires</h2>
                        <p>Le site peut contenir des liens vers des sites externes, notamment :</p>
                        <ul>
                            <li>Leboncoin (pour nos annonces de vente)</li>
                            <li>Facebook Marketplace (pour nos annonces de vente)</li>
                            <li>Sites institutionnels ou partenaires</li>
                        </ul>
                        <p>CC Débarras 14 n'exerce aucun contrôle sur ces sites externes et décline toute responsabilité quant à leur contenu, leur disponibilité ou les dommages qui pourraient résulter de leur utilisation.</p>
                    </section>

                    <section className="legal-section">
                        <h2>9. Protection des données personnelles</h2>
                        <p>La collecte et le traitement des données personnelles sont régis par notre <strong>Politique de Confidentialité</strong>, conforme au Règlement Général sur la Protection des Données (RGPD).</p>
                        <p>Les données collectées via le site (formulaire de contact, navigation) sont utilisées uniquement dans le cadre de nos prestations et ne sont pas transmises à des tiers à des fins commerciales sans consentement.</p>
                        <p>L'utilisateur dispose de droits sur ses données (accès, rectification, effacement, etc.) qu'il peut exercer en nous contactant.</p>
                    </section>

                    <section className="legal-section">
                        <h2>10. Cookies et technologies de suivi</h2>
                        <p>Le site utilise des cookies techniques nécessaires à son bon fonctionnement, notamment pour :</p>
                        <ul>
                            <li>Assurer le fonctionnement du formulaire de contact</li>
                            <li>Mémoriser les préférences de navigation</li>
                            <li>Analyser le trafic du site (de manière anonymisée)</li>
                        </ul>
                        <p>L'utilisateur peut paramétrer son navigateur pour refuser certains cookies, mais cela peut affecter le fonctionnement optimal du site.</p>
                    </section>

                    <section className="legal-section">
                        <h2>11. Modification des CGU</h2>
                        <p>CC Débarras 14 se réserve le droit de modifier les présentes CGU à tout moment pour s'adapter aux évolutions légales, techniques ou commerciales.</p>
                        <p>Les modifications prendront effet dès leur publication sur le site. Il est conseillé de consulter régulièrement cette page pour prendre connaissance des éventuelles modifications.</p>
                        <p>L'utilisation continue du site après modification vaut acceptation des nouvelles conditions.</p>
                    </section>

                    <section className="legal-section">
                        <h2>12. Droit applicable et juridiction</h2>
                        <p>Les présentes CGU sont soumises au droit français. En cas de litige relatif à l'interprétation ou à l'exécution des présentes, et après recherche d'une solution amiable, les tribunaux français seront seuls compétents.</p>
                        <p>La juridiction compétente sera celle du ressort du siège social de CC Débarras 14, sauf dispositions légales contraires.</p>
                    </section>

                    <section className="legal-section">
                        <h2>13. Dispositions diverses</h2>
                        <h3>13.1 Intégralité du contrat</h3>
                        <p>Les présentes CGU constituent l'intégralité des conditions régissant l'utilisation du site.</p>
                        
                        <h3>13.2 Nullité partielle</h3>
                        <p>Si une clause des présentes CGU était déclarée nulle ou non applicable, les autres clauses demeureraient en vigueur.</p>
                        
                        <h3>13.3 Non-renonciation</h3>
                        <p>Le fait pour CC Débarras 14 de ne pas se prévaloir d'une clause des présentes CGU ne constitue pas une renonciation à s'en prévaloir ultérieurement.</p>
                    </section>

                    <section className="legal-section">
                        <h2>14. Contact</h2>
                        <p>Pour toute question relative aux présentes CGU, à l'utilisation du site ou à nos services :</p>
                        <p><strong>CC Débarras 14 - MADAME CARINE GAUTHERIE</strong></p>
                        <p><strong>Adresse :</strong> RUE DES GENETS 7598 LE BIEF DU MOULIN, 14800 SAINT-ARNOULT</p>
                        <p><strong>Téléphone :</strong> <a href="tel:0767567254">07 67 56 72 54</a></p>
                        <p><strong>Email :</strong> <a href="mailto:ccdebarras14@gmail.com">ccdebarras14@gmail.com</a></p>
                        <p><strong>SIREN :</strong> 848 965 612</p>
                    </section>

                    <section className="legal-section">
                        <p><strong>Date de dernière mise à jour :</strong> 15/08/2025</p>
                    </section>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default TermOfUse;